import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
import animations from 'src/styles/animations';
const useStyles = makeStyles(_objectSpread(_objectSpread({}, animations.pulse), {}, {
  balanceStatus: {
    position: 'relative',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '16px',
    minWidth: '16px',
    height: '16px',
    borderRadius: '50%',
    marginLeft: '4px',
    backgroundColor: palette.error.light,
    '&:after': {
      content: '""',
      display: 'inline-block',
      width: '6px',
      height: '6px',
      position: 'relative',
      borderRadius: '50%'
    }
  },
  balanceCritical: {
    backgroundColor: palette.error.light,
    '&:after': {
      backgroundColor: palette.error.main,
      animation: '$pulse 1.4s infinite cubic-bezier(0.4, 0, 0.2, 1)'
    }
  },
  balanceOk: {
    backgroundColor: palette.success.light,
    '&:after': {
      backgroundColor: palette.success.main
    }
  },
  balanceDue: {
    backgroundColor: palette.warning.light,
    '&:after': {
      backgroundColor: palette.warning.main
    }
  },
  balanceDisabled: {
    backgroundColor: palette.shades[300],
    '&:after': {
      backgroundColor: palette.shades[500]
    }
  },
  statusText: {
    marginLeft: '10px'
  }
}));
export default useStyles;